'use client';

import { captureAnalyticsClientEvent } from '@/analytics/analytics-client';
import { buildCmsWorkspaceLaunchDetail } from '@/cms/components/blocks/workspace/workspace-launch-detail';
import { dispatchCmsWorkspaceLaunch } from '@/cms/components/blocks/workspace/workspace-launch-event';
import type { CmsWorkspaceLaunchContext } from '@/cms/workspace/launch-context';
import type { MouseEvent, ReactNode } from 'react';

export function CmsPrimaryCtaTrigger({
  children,
  className,
  dataAttributes,
  workspaceLaunchContext,
}: {
  children: ReactNode;
  className?: string;
  dataAttributes?: Readonly<Record<string, string>>;
  workspaceLaunchContext?: CmsWorkspaceLaunchContext;
}) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    captureAnalyticsClientEvent('cta_clicked', {
      cta_location: 'site_header',
      cta_target: 'workspace',
      tool_id: workspaceLaunchContext?.defaultToolId ?? null,
    });

    dispatchCmsWorkspaceLaunch(
      buildCmsWorkspaceLaunchDetail(workspaceLaunchContext)
    );
  };

  return (
    <button
      {...dataAttributes}
      type="button"
      className={className}
      onClick={handleClick}
    >
      {children}
    </button>
  );
}
